import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { DeletePerformanceRule, DeletePerformanceRuleVariables } from './__generated__/DeletePerformanceRule';

const DELETE_PERFORMANCE_RULE_MUTATION = gql`
  mutation DeletePerformanceRuleMutation($id: ID!) {
    deletePerformanceRule(id: $id) {
      success
      errors
    }
  }
`;

export const useDeletePerformanceRuleMutation = () => {
  return useMutation<DeletePerformanceRule, DeletePerformanceRuleVariables>(DELETE_PERFORMANCE_RULE_MUTATION, {
    client: kmsClient
  });
};
